import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  inventoryController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    'dashboardService',
    '$filter',
    '$state',
    'EXT_ICONS',
    '$sce',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      dashboardService,
      $filter,
      $state
    ) {
      'use strict';

      function loadUsers() {
        dashboardService.getUsersFilter().then((res) => {
          $scope.users = res;
        });
      }

      function isDateField() {
        return $scope.filterByDate;
      }

      function showUsersField() {
        return $scope.filterByUser;
      }

      function isBetweenDates() {
        if (!$scope.newForm.dateFilter) return false;
        if (!$scope.newForm.dateFilter.$modelValue) return false;
        var dateFilter = $scope.newForm.dateFilter.$modelValue.value;
        return $scope.isDateField && dateFilter === 3;
      }

      function saveAsPdf() {
        var filter = {};
        filter.ReportType = 5;
        filter.NoDate = true;
        filter.NoFilter = true;

        if ($scope.selectedUser) {
          filter.NoFilter = false;
          filter.IdUser = $scope.selectedUser.Id;
        }

        if ($scope.isDateField()) {
          filter.NoFilter = false;
          filter.NoDate = false;
          var dateFilter = $scope.newForm.dateFilter.$modelValue.value;
          filter.dateFilterType = dateFilter;
          if ($scope.isBetweenDates()) {
            filter.startDate = $scope.newForm.startDate.$modelValue;
            filter.endDate = $scope.newForm.endDate.$modelValue;
          }
        }

        $scope.revisions = [];
        swal.fire({
          title: $filter('translate')('WAIT GENERATING REPORT'),
          icon: 'info',
          showConfirmButton: false,
          showCancelButton: false,
        });
        $scope.filter = filter;
        dashboardService
          .generateAdditionalFieldReport($scope.filter)
          .then((res) => {
            if (res.size !== 0) {
              var url = URL.createObjectURL(res);
              window.open(url);
              swal.close();
            } else {
              swal.fire({
                title: 'Relatório em branco',
                text: 'Não existem dados para serem exibidos neste relatório com os filtros selecionados.',
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: $filter('translate')('OK'),
              });
            }
          })
          .catch((error) => {
            swal.fire({
              title: error.title,
              text: error.text,
              icon: 'error',
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
            });
          });
      }

      function onSelectUser(value) {
        if (arguments.length === 0) return $scope.selectedUser;
        $scope.value = '';
        $scope.selectedUser = value;
        $scope.revisions = [];
      }

      function run() {
        try {
          $scope.filter;
          $scope.revisions = [];

          $scope.dateFilters = [
            {
              key: 'Hoje',
              value: 0,
            },
            {
              key: '1 semana atrás',
              value: 1,
            },
            {
              key: '1 mês atrás',
              value: 2,
            },
            {
              key: 'Entre datas',
              value: 3,
            },
          ];

          $scope.dateFilter = {
            key: 'Hoje',
            value: 0,
          };

          $scope.startDate;
          $scope.endDate;
          $scope.listOptions = [];

          $scope.filterByUser = false;
          $scope.filterByDate = false;
          $scope.selectedUser;

          $scope.users = [];

          $scope.loadUsers = logWrapper(
            loadUsers,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isDateField = logWrapper(
            isDateField,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showUsersField = logWrapper(
            showUsersField,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isBetweenDates = logWrapper(
            isBetweenDates,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.saveAsPdf = logWrapper(
            saveAsPdf,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.onSelectUser = logWrapper(
            onSelectUser,
            runtimeConstant.isDebugControllersInternals
          );

          $rootScope.$broadcast('clearSearchTerm');

          $scope.imageTypes = ['png', 'gif', 'jpeg', 'jpg', 'bmp'];

          $scope.title = '';
          $scope.description = '';
          $scope.searchTerm = '';

          if ($state.params.id) {
            $scope.idfolder = parseInt($state.params.id);
          }

          $scope.loadUsers();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
